/* eslint-disable no-undef */
// export function getAccessToken(): Promise<string | null> {
//     return new Promise((resolve) => {
//         let accessToken: string | null = sessionStorage.getItem("accessToken");

//         /**
//          * Check if the token is expired
//          */
//         if (accessToken && isTokenExpired(accessToken)) {
//             console.log("Token is expired. Waiting for a new token via postMessage...");
//             accessToken = null; // Set to null to wait for a new token
//             sessionStorage.removeItem("accessToken"); // Remove the expired token
//         }

//         /**
//          * If a valid token is in session storage, resolve immediately
//          */
//         if (accessToken) {
//             resolve(accessToken);
//             return;
//         }

//         /**
//          * Otherwise, wait for the token to be sent via postMessage
//          */
//         const messageHandler = (event: MessageEvent) => {
//             // Ensure the message is coming from a trusted source
//             if (event.origin !== import.meta.env.VITE_BACKEND_UI_URL) {
//                 console.warn("Received message from untrusted origin:", event.origin);
//                 return;
//             }

//             if (event.data && event.data.token) {
//                 accessToken = event.data.token;

//                 // Store the token in memory and sessionStorage
//                 sessionStorage.setItem("accessToken", accessToken ?? '');

//                 // Resolve the promise with the token
//                 resolve(accessToken);

//                 // Remove the event listener once the token is received
//                 window.removeEventListener("message", messageHandler);
//             }
//         };

//         window.addEventListener("message", messageHandler);
//         console.log("Waiting for token via postMessage...");
//     });
// }

export function getApplicationCode() {
    const urlParams = new URLSearchParams(window.location.search);
    let applicationCode = urlParams.get("application_code");

    if (applicationCode) {
        applicationCode = applicationCode.replace("/", "");
    }

    /**
     * Set application code in session storage
     */
    if (applicationCode) {
        sessionStorage.setItem("applicationCode", applicationCode);
    }

    return applicationCode;
}
